module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "sign"
  }, [_vm._v(_vm._s(_vm.formatedPrice.sign))]), _c('span', {
    staticClass: "symbol"
  }, [_vm._v("¥ ")]), _c('span', {
    staticClass: "int"
  }, [_vm._v(_vm._s(_vm.formatedPrice.int))]), _vm._v("."), _c('span', {
    staticClass: "decimal"
  }, [_vm._v(_vm._s(_vm.formatedPrice.decimal))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f6f88f6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/price/index.vue
// module id = 86
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 24 26 27 28 29 30 31 32 33 34 35 36 37 38 40 42 48 54 58 65 66 67 70 71 75 78 80 81 85 90